// A modal confirmation dialog, resolved as a Promise<boolean>. Used to guard
// destructive actions (removing a friend, leaving/deleting a group, removing a
// member). Overlays the phone frame like the toasts do.

import $ from 'jquery';
import { esc } from './dom';

interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Style the confirm button as destructive (red). Defaults to true. */
  danger?: boolean;
}

export function confirmDialog(opts: ConfirmOptions): Promise<boolean> {
  const confirmLabel = opts.confirmLabel ?? 'Onayla';
  const cancelLabel = opts.cancelLabel ?? 'Vazgeç';
  const danger = opts.danger ?? true;

  return new Promise((resolve) => {
    const $overlay = $(`
      <div class="modal-overlay" role="dialog" aria-modal="true">
        <div class="modal">
          <h3 class="modal__title">${esc(opts.title)}</h3>
          <p class="modal__message">${esc(opts.message)}</p>
          <div class="modal__actions">
            <button type="button" class="btn btn--ghost" data-act="cancel">${esc(cancelLabel)}</button>
            <button type="button" class="btn ${danger ? 'btn--danger' : 'btn--primary'}" data-act="confirm">${esc(confirmLabel)}</button>
          </div>
        </div>
      </div>
    `);

    let settled = false;
    const close = (result: boolean): void => {
      if (settled) return;
      settled = true;
      $overlay.removeClass('is-in');
      setTimeout(() => $overlay.remove(), 200);
      resolve(result);
    };

    $overlay.on('click', '[data-act="confirm"]', () => close(true));
    $overlay.on('click', '[data-act="cancel"]', () => close(false));
    // Click on the backdrop (outside the dialog) cancels.
    $overlay.on('click', (e) => {
      if (e.target === $overlay[0]) close(false);
    });

    $('#device-frame').append($overlay);
    requestAnimationFrame(() => $overlay.addClass('is-in'));
  });
}
